import {
  GET_LIST_KIEMTRANOXAU,
  GET_LIST_KIEMTRANOXAU_SUCCESS,
  GET_LIST_KIEMTRANOXAU_FAILURE,
} from "./actionTypes";

export const getListKiemTraNoXau = (dataSearch) => ({
  type: GET_LIST_KIEMTRANOXAU,
  dataSearch,
});

export const getListKiemTraNoXauSuccess = (data) => ({
  type: GET_LIST_KIEMTRANOXAU_SUCCESS,
  payload: data,
});

export const getListKiemTraNoXauFailure = () => ({
  type: GET_LIST_KIEMTRANOXAU_FAILURE,
});
